<template>
  <div class="dropdown-search-wrap">
    <h4 class="text-block-title">
      {{ $t('CONTACT_PANEL.CONCURRENTS.CONCURRENT_SELECT.TITLE') }}
    </h4>
    <div class="search-wrap">
      <input
        ref="searchbar"
        v-model="search"
        type="text"
        class="search-input"
        autofocus="true"
        :placeholder="$t('CONTACT_PANEL.CONCURRENTS.CONCURRENT_SELECT.PLACEHOLDER')"
      />
    </div>
    <div class="list-wrap">
      <div class="list">
        <woot-dropdown-menu>
          <concurrent-label-dropdown-item
            v-for="concurrentLabel in filteredActiveConcurrentLabels"
            :key="concurrentLabel.title"
            :title="concurrentLabel.title"
            :color="concurrentLabel.color"
            :selected="selectedConcurrentLabels.includes(concurrentLabel.title)"
            @click="onAddRemove(concurrentLabel)"
          />
        </woot-dropdown-menu>
        <div v-if="noResult" class="no-result">
          {{ $t('CONTACT_PANEL.CONCURRENTS.CONCURRENT_SELECT.NO_RESULT') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConcurrentLabelDropdownItem from './ConcurrentLabelDropdownItem';
export default {
  components: {
    ConcurrentLabelDropdownItem,
  },

  props: {
    accountConcurrentLabels: {
      type: Array,
      default: () => [],
    },
    selectedConcurrentLabels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      search: '',
    };
  },

  computed: {
    filteredActiveConcurrentLabels() {
      return this.accountConcurrentLabels.filter(concurrentLabel => {
        return concurrentLabel.title
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },

    noResult() {
      return this.filteredActiveConcurrentLabels.length === 0 && this.search !== '';
    },
  },

  mounted() {
    this.focusInput();
  },

  methods: {
    focusInput() {
      this.$refs.searchbar.focus();
    },

    updateConcurrentLabels(concurrentLabel) {
      this.$emit('update', concurrentLabel);
    },

    onAdd(concurrentLabel) {
      this.$emit('add', concurrentLabel);
    },

    onRemove(concurrentLabel) {
      this.$emit('remove', concurrentLabel);
    },

    onAddRemove(concurrentLabel) {
      if (this.selectedConcurrentLabels.includes(concurrentLabel.title)) {
        this.onRemove(concurrentLabel.title);
      } else {
        this.onAdd(concurrentLabel);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-search-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 20rem;

  .search-wrap {
    margin-bottom: var(--space-small);
    flex: 0 0 auto;
    max-height: var(--space-large);

    .search-input {
      margin: 0;
      width: 100%;
      border: 1px solid transparent;
      height: var(--space-large);
      font-size: var(--font-size-small);
      padding: var(--space-small);
      background-color: var(--color-background);
    }

    input:focus {
      border: 1px solid var(--w-500);
    }
  }

  .list-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1 1 auto;
    overflow: auto;

    .list {
      width: 100%;
    }

    .no-result {
      display: flex;
      justify-content: center;
      color: var(--s-700);
      padding: var(--space-smaller) var(--space-one);
      font-weight: var(--font-weight-medium);
      font-size: var(--font-size-small);
    }
  }
}
</style>

